var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.form)?_c('rkm-area',{attrs:{"title":"Protocolo","type":"fieldset"}},[_c('Form',{attrs:{"data":_vm.data,"is-atendimento-medico":_vm.isAtendimentoMedico,"readonly":_vm.readonly}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }